import { Component } from '@theme/component';

class CoachCutter extends Component {
  connectedCallback() {
    super.connectedCallback();
    if (this.controller) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.dialog = this.querySelector('dialog');
    this.launch = this.querySelector('[data-cc-open]');
    this.character = this.querySelector('[data-cc-character]');
    if (!this.dialog || !this.launch || !this.character) return;
    this.launch.hidden = false;
    this.launch.addEventListener('click', () => {
      this.selectCategory(this.dataset.defaultCategory || 'foundation');
      this.dialog.showModal();
      this.launch.setAttribute('aria-expanded', 'true');
    }, { signal });
    this.querySelector('[data-cc-close]').addEventListener('click', () => this.dialog.close(), { signal });
    this.dialog.addEventListener('close', () => {
      this.launch.setAttribute('aria-expanded', 'false');
      this.launch.focus();
    }, { signal });
    this.querySelector('#CoachCutterNewsletter')?.addEventListener('submit', () => {
      if (this.dialog.open) this.dialog.close();
    }, { signal });
    this.dialog.addEventListener('click', (event) => {
      if (event.target instanceof Element && event.target.closest('a')) {
        this.dialog.close();
        return;
      }
      if (event.target !== this.dialog) return;
      const rect = this.dialog.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
    }, { signal });
    this.querySelectorAll('[data-cc-category]').forEach((button) => {
      button.addEventListener('click', () => this.selectCategory(button.dataset.ccCategory), { signal });
    });
    this.querySelectorAll('[data-cc-topic]').forEach((question) => {
      question.querySelector('summary').addEventListener('click', () => {
        this.setMood(question.dataset.ccMood || 'explain');
      }, { signal });
      question.addEventListener('toggle', () => {
        if (!question.open) return;
        this.querySelectorAll('[data-cc-topic]').forEach((other) => {
          if (other !== question) other.open = false;
        });
      }, { signal });
    });
    if (this.querySelector('[data-cc-signup-state]')) {
      this.selectCategory('updates');
      this.dialog.showModal();
      this.launch.setAttribute('aria-expanded', 'true');
    }
  }

  selectCategory(category) {
    this.activeCategory = category;
    this.querySelectorAll('[data-cc-category]').forEach((button) => {
      button.setAttribute('aria-pressed', String(button.dataset.ccCategory === category));
    });
    this.querySelectorAll('[data-cc-topic]').forEach((question) => {
      question.open = false;
      question.hidden = question.dataset.ccTopic !== category;
    });
    this.querySelector('[data-cc-updates]').hidden = category !== 'updates';
    this.querySelector('.cc-hint').hidden = category === 'updates';
    this.querySelector('[data-cc-rule-note]').hidden = !['folkstyle', 'freestyle', 'greco'].includes(category);
    this.querySelector('.cc-scroll').scrollTop = 0;
    if (category === 'game') {
      this.setMood('welcome');
    } else if (this.character.dataset.sheet === 'topic' && this.character.dataset.topic === category) {
      this.setMood('explain');
    } else {
      this.character.dataset.sheet = 'topic';
      this.character.dataset.topic = category;
      this.character.dataset.mood = category;
      this.animateCharacter();
    }
  }

  setMood(mood) {
    const moods = ['welcome', 'think', 'explain', 'encourage'];
    const sheet = this.activeCategory === 'game' ? 'card' : 'coach';
    if (this.character.dataset.sheet === sheet) {
      mood = moods[(moods.indexOf(this.character.dataset.mood) + 1) % moods.length];
    }
    this.character.dataset.sheet = sheet;
    this.character.dataset.mood = mood;
    this.animateCharacter();
  }

  animateCharacter() {
    this.character.classList.remove('is-speaking');
    cancelAnimationFrame(this.motionFrame);
    this.motionFrame = requestAnimationFrame(() => this.character.classList.add('is-speaking'));
  }

  disconnectedCallback() {
    this.controller?.abort();
    this.controller = null;
    cancelAnimationFrame(this.motionFrame);
    if (this.dialog?.open) this.dialog.close();
    super.disconnectedCallback();
  }
}

if (!customElements.get('coach-cutter')) customElements.define('coach-cutter', CoachCutter);
